import axios from "axios";
import { API } from "../API_CONFIG";
export const BASE_URL = API;

export const getProfileDetails = async (accessToken, userFeatures) => {
  var config = {
    method: "get",
    url: `${BASE_URL.providerNode}/provider/ProfileDetails`,
    headers: {
      "Content-Type": "application/json",
      accesstoken: accessToken,
      userfeatures: userFeatures,
    },
  };
  let response = await axios(config);
  return response;
};

export const axiosWithRetry = async (config, maxRetries = 3) => {
  for (let attempt = 0; attempt < maxRetries + 1; attempt++) {
    try {
      const a = await axios(config);
      return a;
    } catch (error) {
      // On last attempt, or non-retryable error, just throw
      const isRetryable =
        !error.response || (error.response && error.response.status >= 500);
      if (attempt === maxRetries || !isRetryable) {
        throw error;
      }

      // Log and wait before retry
      console.error(`API retry attempt ${attempt + 1}: ${error.message}`);
      await new Promise((resolve) => setTimeout(resolve, (attempt + 1) * 1000));
    }
  }
};
